import React, { PureComponent, ReactNode } from 'react';
import b from 'b_';

interface Props {
    title: string;
    description?: ReactNode;
    top?: ReactNode;
    content: ReactNode;
    className?: string;
}

const class_ = b.with('block');

export default class ContentBlock extends PureComponent<Props> {
    public render() {
        const { top, title, description, content, className = '' } = this.props;

        return (
            <div className={`${class_()} ${className}`}>
                <div className={class_('head')}>
                    <div className={class_('title')}>
                        {title}
                    </div>
                    {top}
                </div>
                {description &&
                    <div className={class_('description')}>
                        {description}
                    </div>
                }
                {content}
            </div>
        );
    }
}
